module.exports = __webpack_public_path__ + "img/we_are.cd2a37a4.png";